import { faPhoneHangup } from '@fortawesome/pro-solid-svg-icons';
import { twMerge } from 'tailwind-merge';

import { Button, ButtonProps, IconButton } from '@growtherapy/sprout-ui';

export function EndSessionButton({
  children,
  className,
  ...props
}: ButtonProps & {
  'aria-label': string;
}) {
  return (
    <>
      <IconButton
        id='end-session-button-mobile'
        className='md:hidden min-w-12 max-w-12 min-h-12 max-h-12 justify-center p-0'
        use='destructive'
        iconDefinition={faPhoneHangup}
        {...props}
      />
      <Button
        id='end-session-button'
        use='destructive'
        {...props}
        className={twMerge('hidden md:inline-flex items-center justify-center', className)}
      >
        {children}
      </Button>
    </>
  );
}
